export default {
  title: 'Accueil',
  welcome: {
    title: 'Bienvenue {name}',
    subtitle: 'Gérez votre contenu vidéo, vos chaînes et vos analyses en un seul endroit',
    memberSince: 'Membre depuis {date}',
    upgradeButton: 'Passer à l\'offre Pro',
    upgradeSubtitle: 'Débloquez toutes les fonctionnalités'
  },
  apps: {
    title: 'Nos outils',
    description: 'Explorez nos outils puissants pour créer, gérer et partager vos contenus.',
    comingSoon: 'À venir'
  },
  tutorials: {
    title: 'Nos tutos',
    description: 'Notre centre d\'aide vous accompagne pour prendre en main notre solution.',
    viewAll: 'Centre d\'aide',
    unlockPro: 'Débloquer Pro',
    items: {
      gettingStarted: {
        title: 'Premier pas',
        description: 'Découvrez les fonctionnalités de base et commencez rapidement'
      },
      uploadVideo: {
        title: 'Importez une vidéo',
        description: 'Apprenez à téléverser et organiser vos contenus vidéo'
      },
      sellVideos: {
        title: 'Vendez vos vidéos',
        description: 'Monétisez vos contenus avec nos outils de vente intégrés'
      }
    }
  },
  blog: {
    title: 'Blog',
    description: 'Suivez notre actualité, nos nouveautés et nos conseils vidéo.',
    viewAll: 'Voir tout le blog',
    categories: {
      product: 'Produit',
      tips: 'Conseils',
      bestPractices: 'Bonnes pratiques',
      data: 'Data'
    },
    articles: {
      webTvGuide: {
        title: 'Lancer une Web TV interne : guide complet pour engager vos équipes',
        excerpt: 'De la structuration des chaînes à la gestion des droits, découvrez comment déployer une Web TV interne performante et sécurisée.'
      },
      subtitlesBestPractices: {
        title: 'Sous-titrage automatique : 5 bonnes pratiques pour un rendu pro',
        excerpt: 'Améliorez l\'accessibilité et le SEO de vos vidéos avec ces conseils simples pour optimiser vos sous-titres.'
      },
      organizeMediaLibrary: {
        title: 'Comment organiser votre médiathèque : tags, dossiers et espaces',
        excerpt: 'Une méthode claire pour structurer vos médias et accélérer la recherche au quotidien.'
      },
      videoAnalytics: {
        title: 'Analytics vidéo : les métriques qui comptent vraiment',
        excerpt: 'Taux de complétion, engagement, sources de trafic… faites parler vos données.'
      }
    }
  },
  quickActions: {
    title: 'Actions rapides',
    uploadAssets: 'Téléverser des médias',
    uploadAssetsDesc: 'Ajouter de nouvelles vidéos',
    createChannel: 'Créer une chaîne',
    createChannelDesc: 'Démarrer une nouvelle chaîne',
    createShowcase: 'Créer une vitrine',
    createShowcaseDesc: 'Créer une page de présentation',
    viewAnalytics: 'Voir les analyses',
    viewAnalyticsDesc: 'Vérifier vos performances'
  },
  recentActivity: {
    title: 'Activité récente',
    uploadedVideo: 'Téléversé une nouvelle vidéo',
    createdChannel: 'Créé une nouvelle chaîne',
    publishedShowcase: 'Publié une vitrine',
    startedStream: 'Démarré un stream en direct',
    minutesAgo: 'Il y a {count} minutes',
    hoursAgo: 'Il y a {count} heures',
    daysAgo: 'Il y a {count} jours'
  },
  faq: {
    title: 'FAQ',
    description: 'Trouvez réponses aux questions les plus fréquentes',
    items: {
      monetization: {
        question: 'Comment monétiser son contenu ?',
        answer: 'Vous pouvez monétiser vos vidéos via des ventes directes, des abonnements, ou des intégrations sur une chaîne payante.'
      },
      addContent: {
        question: 'Comment ajouter du contenu sur ma chaîne ?',
        answer: 'Cliquez sur "Ajouter une vidéo" depuis votre tableau de bord ou glissez-déposez vos fichiers directement.'
      },
      secureSharing: {
        question: 'Est-ce que je peux partager une vidéo à une personne de façon sécurisée ?',
        answer: 'Oui, vous pouvez générer un lien privé avec mot de passe ou durée de validité.'
      },
      embedVideos: {
        question: 'Est-ce que je peux intégrer des vidéos Videas sur mon site internet ?',
        answer: 'Bien sûr. Chaque vidéo peut être intégrée via un code embed responsive.'
      },
      addSubtitles: {
        question: 'Comment ajouter des sous-titres à ma vidéo ?',
        answer: 'Rendez-vous dans l\'onglet "Sous-titres" d\'une vidéo pour importer ou générer automatiquement des fichiers.'
      }
    }
  },
  recentMedia: {
    title: 'Médias récents',
    description: 'Accédez rapidement à vos derniers fichiers pour les organiser, partager ou analyser.',
    emptyState: {
      title: 'Aucun média récent',
      description: 'Importez votre premier fichier pour le voir apparaître ici.',
      uploadButton: 'Importer des médias'
    },
    table: {
      file: 'Fichier',
      space: 'Espace',
      type: 'Type',
      addedDate: 'Ajouté le'
    }
  }
}
